import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // 로딩 중일 때
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">로딩 중...</p>
        </div>
      </div>
    );
  }

  // 인증되지 않았을 때 - Navigate 컴포넌트로 즉시 리다이렉트
  if (!isAuthenticated) {
    const currentPath = location.pathname + location.search;
    return <Navigate to={`/auth?redirectTo=${encodeURIComponent(currentPath)}`} replace />;
  }

  // 인증된 사용자 - 자식 컴포넌트 렌더링
  return <>{children}</>;
};

export default ProtectedRoute;